import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { IBIK } from '@nxsys/types/models/BIK';
import React, { useRef, useState } from 'react';
import ShareBasedRemunerationForm, {
  ShareBasedRemunerationFormRef,
  ShareBasedRemunerationFormValues,
} from './ShareBasedRemunerationForm';

type EditShareBasedRemunerationProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: ShareBasedRemunerationFormValues) => Promise<void>;
  data: IBIK;
};

const EditShareBasedRemunerationModal: React.FC<
  EditShareBasedRemunerationProps
> = ({ isOpen, toggle, onSubmit, data }: EditShareBasedRemunerationProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<ShareBasedRemunerationFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: ShareBasedRemunerationFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editShareBasedRemuneration']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <ShareBasedRemunerationForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          value: data.value?.toString(),
          taxPeriod: data.taxPeriod,
          eeContribution: data.eeContribution?.toString(),
          description: data.description,
        }}
      />
    </AppModalContainer>
  );
};

export default EditShareBasedRemunerationModal;
